import React, { useEffect, useRef, useState } from 'react';
import AuthLayout from '../layout/AuthLayout';
import { useNavigate } from 'react-router-dom';
import { CallWithAuth } from '../action/apiActions';
import { GET_QUESTION_BANK, GET_USERS } from '../action/apiPath';
import moment from 'moment/moment';
import RightPanelTopMenu from '../component/molecule/common/RightPanelTopMenu';
import FilterModal from '../component/atoms/Modal/FilterModal';
import QuestionListModal from '../component/atoms/Modal/QuestionListModal';
import style from '../assets/styles/createQuestion.module.css';
import PreviewModal from '../component/atoms/Modal/PreviewModal';
import LockModal from '../component/atoms/Modal/LockModel';
import { useToast } from '../component/molecule/common/Toast';
import { Pagination } from '../component/molecule/common/Pagination';
import { openPreviewModal, closePreviewModal } from '../component/atoms/Modal/modalHandlers';
import { editQuestionHandler } from '../component/atoms/Modal/editHandlers';
import { handleDuplicate, openModalHelper, closeModalHelper } from '../component/atoms/Modal/duplicateHelper';
import { handleConfirmDuplicate } from '../component/atoms/Modal/duplicateInPreviewHelper';
import passageVerticalLineSvg from '../../src/assets/images/passageVerticalLine.svg';
const QuestionBank = () => {
  const toast = useToast();
  const [modalMedium, setModalMedium] = useState(false);

  // Initialize state for the selected year
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedYearExclude, setSelectedYearExclude] = useState('');
  const [questionType, setQuestionType] = useState('');
  const [questionFormat, setQuestionFormat] = useState('');
  const [difficultyLevel, setDifficultyLevel] = useState('');
  // _________ PRIMARY TAG STATE INITIALIZATION _________
  const [questionId, setquestionId] = useState('');
  const [multiselectedSubjectTag, setmultiSelectedSubjectTag] = useState([]);
  const [multiselectedFreeTag, setmultiSelectedFreeTag] = useState([]);
  const [multiselectedCategoryTag, setmultiSelectedCategoryTag] = useState([]);
  const [multiselectedAuthorTag, setmultiSelectedAuthorTag] = useState([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [modalModalData] = useState({
    title: 'This Question is Linked to Existing Tests',
    description:
      'The question you are about to edit has been used in one or more tests. Please be sure to click the ‘Update Exam’ button to update the changes across all tests that include this question.',
    cancelButton: 'Cancel',
    saveButton: 'Continue',
    substitle: 'Are you sure you want to proceed with editing this question?',
  });
  const openModalMedium = () => {
    setModalMedium(true);
  };
  const closeModalMedium = () => {
    setModalMedium(false);
  };
  const navigate = useNavigate();
  // ________ button for navigating to create question ________
  const CreateQuestion = () => {
    navigate('/create-question', {
      state: { selectedQueBankId: questionBankId },
    });
  };

  const [totalCount, setTotalCount] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [limit] = useState(5);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isPreviewopen, setIsPreviewopen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null); // State to store dataToPass
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const [groupedQuestions, setGroupedQuestions] = useState([]);
  const maxSiblingsToShow = 5; // Limit to show only 5 siblings
  const [showMoreState, setShowMoreState] = React.useState({}); // Object to hold the state of each row
  const [isDuplicatePreview, setIsDuplicatePreview] = useState(false); // State to store dataToPass
  const [isDraft, setIsDraft] = useState(false);
  const [organizationId, setOrganizationId] = useState(() => {
    const storedId = localStorage.getItem('selectedOrgId');
    return storedId ? Number(storedId) : 1;
  });
  const userRolesInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}').roles || [];
  const isSuperAdmin = userRolesInfo.some((role) => role.id === 1);
  // Get the current year
  const currentYear = new Date().getFullYear();
  const [resettingFilters, setResettingFilters] = useState(false);
  const [sort, setSort] = useState('');
  const [questionAccess, setQuestionAccess] = useState({});
  const [questionItem, setQuestionItem] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const toggleShowMore = (rowId) => {
    // eslint-disable-next-line no-console
    setShowMoreState((prevState) => ({
      ...prevState,
      [rowId]: !prevState[rowId], // Toggle the specific row's state
    }));
  };
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('isDuplicatePreview', isDuplicatePreview);
  }, [isModalOpen, modalData, isDuplicatePreview]);
  // _________question bank id which is top dropdown _________
  const [questionBankId, setQuestionBankId] = useState(null);

  // _________which one to show my or all _________
  const [questionCategory, setQuestionCategory] = useState(false);
  const ChangeQuestionCategory = (e, draft) => {
    setSort('-created_at');
    setSortConfig({ field: 'created_at', direction: 'desc', sort: '-created_at' });
    setQuestionCategory(e);
    setIsDraft(draft);
  };

  // _________ALL question created listing data _________
  const [questionResults, setQuestionResults] = useState([]);

  const groupQuestionsByParent = (questions) => {
    const grouped = {};

    questions.forEach((question) => {
      // Extract question_id and siblings
      const { question_id, siblings } = question;

      // Group by question_id and include siblings
      grouped[question_id] = siblings;
    });
    return grouped;
  };

  const QuestionListing = async () => {
    setIsLoading(true);
    const url =
      GET_QUESTION_BANK +
      questionBankId +
      '/question-listing/' +
      organizationId +
      '/?draft=0' +
      '&category=' +
      multiselectedCategoryTag.map((item) => item.id).join(',') +
      '&subject_tags=' +
      multiselectedSubjectTag.map((item) => item.id).join(',') +
      '&free_tags=' +
      multiselectedFreeTag.map((item) => item.id).join(',') +
      '&question_authors=' +
      multiselectedAuthorTag.map((item) => item.id).join(',') +
      '&page=' +
      currentPage +
      '&limit=' +
      limit +
      '&after=' +
      selectedYear +
      '&sort=' +
      sort +
      '&before=' +
      selectedYearExclude +
      '&question_type=' +
      questionType +
      '&question_format=' +
      questionFormat +
      '&lod=' +
      difficultyLevel +
      '&question_id=' +
      questionId;

    try {
      const response = await CallWithAuth('GET', url);

      if (response.status && response.res.status === 200) {
        // Extract siblings from the response
        const questions = response.res.data.results;
        // Group questions by their parent
        const groupedQuestions = groupQuestionsByParent(questions);
        const totalResults = response.res.data.count;
        // Set the grouped questions in the state
        setGroupedQuestions(groupedQuestions || []); // Use empty array as fallback
        setQuestionResults(response.res.data.results);
        setTotalCount(totalResults);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setQuestionResults([]);
        setTotalCount(0);
        setCurrentPage(1);
        setOffset(0);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      setIsLoading(false);
      console.error('Error during fetching question listing:', error);
    }
  };

  // useEffect(() => {
  //   QuestionListing(); // Fetch data on component mount
  // }, []);

  // _________ MY question created listing data __________
  const [myquestionResults, setMyquestionResults] = useState([]);

  const MyQuestionListing = async () => {
    setIsLoading(true);
    const baseUrl =
      GET_QUESTION_BANK +
      questionBankId +
      '/question-listing/' +
      organizationId +
      '/?category=' +
      multiselectedCategoryTag.map((item) => item.id).join(',') +
      '&subject_tags=' +
      multiselectedSubjectTag.map((item) => item.id).join(',') +
      '&free_tags=' +
      multiselectedFreeTag.map((item) => item.id).join(',') +
      '&question_authors=' +
      multiselectedAuthorTag.map((item) => item.id).join(',') +
      '&page=' +
      currentPage +
      '&limit=' +
      limit +
      '&after=' +
      selectedYear +
      '&sort=' +
      sort +
      '&before=' +
      selectedYearExclude +
      '&question_type=' +
      questionType +
      '&question_format=' +
      questionFormat +
      '&lod=' +
      difficultyLevel +
      '&question_id=' +
      questionId;

    const url = isDraft ? `${baseUrl}&draft=1&my_questions=true` : `${baseUrl}&draft=0&my_questions=true`;

    const response = await CallWithAuth('GET', url);
    if (response.status && response.res.status === 200) {
      // Extract siblings from the questionlistingData
      const questions = response.res.data.results;
      // Group questions by their parent
      const groupedQuestions = groupQuestionsByParent(questions);

      // Set the grouped questions in the state
      setGroupedQuestions(groupedQuestions || []); // Use empty array as fallback
      setMyquestionResults(response.res.data.results);
      setTotalCount(response.res.data.count);
      setIsLoading(false);
    } else {
      setMyquestionResults([]);
      setTotalCount(0);
      setCurrentPage(1);
      setOffset(0);
      setIsLoading(false);
    }
  };

  // ________ filter modal open  ________
  const [modalFilter, setModalFilter] = useState(false);

  const openModalFilter = () => {
    setModalFilter(true);
  };

  const closeModalFilter = () => {
    setModalFilter(false);
  };

  // _________ YEAR USED-> STATE INITIALIZATION _________

  const userId = JSON.parse(localStorage.getItem('userInfo')).id;
  const [sortConfig, setSortConfig] = useState({
    field: 'created_at',
    direction: 'desc',
    sort: '-created_at',
  });

  const handleSort = (field) => {
    setSortConfig((prevConfig) => {
      let direction, sortValue;

      if (field === 'created_at') {
        if (prevConfig.field !== field) {
          direction = 'desc';
          sortValue = `-${field}`;
        } else {
          // Subsequent clicks toggle between asc and desc
          direction = prevConfig.direction === 'asc' ? 'desc' : 'asc';
          sortValue = direction === 'desc' ? `-${field}` : field;
        }
      } else {
        // General sorting logic for other fields
        direction = prevConfig.field === field && prevConfig.direction === 'asc' ? 'desc' : 'asc';
        sortValue = direction === 'desc' ? `-${field}` : field;
      }

      setSort(sortValue);
      setSortConfig({ field, direction, sort: sortValue });

      // Reset pagination
      setOffset(0);
      setCurrentPage(1);
      return { field, direction, sort: sortValue };
    });
  };
  const getRotation = (field) => {
    if (field === 'created_at') {
      // Handle 'updated_at' specifically for upside-down rotation
      if (sortConfig.sort === '-created_at') return 'rotate(180deg)';
      if (sortConfig.sort === 'created_at') return 'rotate(0deg)';
    }
    if (sortConfig.field !== field) return 'rotate(0deg)';
    return sortConfig.direction === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)';
  };
  // Helper function to get icon color
  const getIconColor = (field) => {
    return sortConfig.field === field ? '#00ABFB' : '#999090';
  };
  const getPermission = async () => {
    const Permission = await CallWithAuth('GET', `${GET_USERS}${userId}/user-details/`);
    if (Permission.status && Permission.res.status === 200) {
      const data = Permission.res.data;
      sessionStorage.setItem('permissionForQuestions', JSON.stringify(data));
    } else if (Permission.status && Permission.res.status === 400) {
      // eslint-disable-next-line no-console
      console.log('Access denied, you do not have permission to access source question bank');
    }
  };
  useEffect(() => {
    getPermission();
  }, []);
  useEffect(() => {
    const Permission = JSON.parse(sessionStorage.getItem('permissionForQuestions') || '{}');
    const newQuestionAccess = Permission?.question_bank_management?.filter((item) => item.id === questionBankId)[0];
    if (Permission && newQuestionAccess) {
      sessionStorage.setItem('questionAccess', JSON.stringify(newQuestionAccess));
      setQuestionAccess(newQuestionAccess);
    } else {
      setQuestionAccess({});
      const payload = { draft: false, edit: false, review: false, view: false, id: questionBankId };
      sessionStorage.setItem('questionAccess', JSON.stringify(payload));
    }
    setCurrentPage(1);
    setOffset(0);
  }, [questionBankId]);

  const resetFilter = () => {
    setCurrentPage(1);
    setDifficultyLevel('');
    setQuestionFormat('');
    setQuestionType('');
    setSelectedYearExclude('');
    setSelectedYear('');
    setmultiSelectedAuthorTag([]);
    setmultiSelectedFreeTag([]);
    setmultiSelectedCategoryTag([]);
    setmultiSelectedSubjectTag([]);
    setResettingFilters(true);
  };
  useEffect(() => {
    if (resettingFilters) {
      // Call API after filter reset
      questionCategory ? QuestionListing() : MyQuestionListing();
      setResettingFilters(false); // reset the flag
    }
  }, [
    currentPage,
    difficultyLevel,
    questionFormat,
    questionType,
    selectedYearExclude,
    selectedYear,
    multiselectedAuthorTag,
    multiselectedFreeTag,
    multiselectedCategoryTag,
    multiselectedSubjectTag,
    resettingFilters,
    isDraft,
  ]);

  useEffect(() => {
    if (!currentPage || currentPage <= 0) {
      return;
    }
    if (questionBankId && organizationId) {
      if (questionCategory) {
        QuestionListing();
      } else {
        MyQuestionListing();
      }
    }
  }, [questionBankId, questionId, offset, sort, questionCategory, currentPage, organizationId, isDraft]);

  // QUESTION maTRIX
  const [questionMatrix, setQuestionMatrix] = useState(null);

  const QuestionMatric = async () => {
    const QuestionMatricData = await CallWithAuth(
      'GET',
      GET_QUESTION_BANK + questionBankId + '/question-matrics/' + organizationId + '/'
    );
    if (QuestionMatricData.status && QuestionMatricData.res.status === 200) {
      setQuestionMatrix(QuestionMatricData.res.data);
    }
  };

  useEffect(() => {
    if (questionBankId) {
      QuestionMatric();
    }
  }, [questionBankId, organizationId]);
  useEffect(() => {
    QuestionMatric();
    if (localStorage.getItem('questionBankId') && localStorage.getItem('questionBankId') !== null) {
      setQuestionBankId(Number(localStorage.getItem('questionBankId')));
    }
  }, [localStorage.getItem('questionBankId')]);

  const [statusOfaction, setstatusOfaction] = useState(false);
  const [actionId, setactionId] = useState(null);
  const lastClickedButtonRef = useRef(null);

  // ACTION OF EDIT
  const ActionPerform = (questionId, event) => {
    if (event) {
      event.stopPropagation();
      lastClickedButtonRef.current = event.currentTarget;
    }
    if (statusOfaction && actionId === questionId) {
      setactionId(null);
      setstatusOfaction(false);
    } else {
      setactionId(questionId);
      setstatusOfaction(true);
    }
  };

  const handleEdit = async (item) => {
    await editQuestionHandler(item, setIsPreviewopen, openModalMedium, setQuestionItem, navigate);
  };

  // ____________ outside click close option ____________
  const rowRef = useRef();
  const statusCssHandler = (status) => {
    if (status === 'Approved') {
      return {
        backgroundColor: '#E9FCF1',
        color: '#26AB5B',
        borderColor: '#26AB5B',
      };
    }
    if (status === 'Rejected') {
      return {
        backgroundColor: '#FFF2F1',
        color: '#FF5757',
        borderColor: '#FF5757',
      };
    } else {
      return {
        backgroundColor: '#FFF9E8',
        color: '#FFCF00',
        borderColor: '#FFCF00',
      };
    }
  };

  const handleRowClick = (event) => {
    // Don't close if clicking the action button or its children
    if (event.target.id === 'edit' || lastClickedButtonRef.current?.contains(event.target)) {
      return;
    }
    setactionId(null);
    setstatusOfaction(false);
  };

  useEffect(() => {
    document.addEventListener('click', handleRowClick);
    return () => {
      document.removeEventListener('click', handleRowClick);
    };
  }, [handleRowClick]);

  // Function to handle opening the preview modal
  const handleOpenModal = (items) => {
    openPreviewModal(items, setSelectedQuestion, setIsPreviewopen);
  };

  const handleCloseModal = () => {
    closePreviewModal(setIsPreviewopen, setIsDuplicatePreview, setIsModalOpen);
  };

  const onConfirmDuplicate = (questionBankId, questionId) => {
    handleConfirmDuplicate(
      organizationId,
      questionBankId,
      questionId,
      setIsModalOpen,
      setIsPreviewopen,
      setIsDuplicatePreview,
      setactionId,
      toast,
      questionCategory,
      QuestionListing,
      MyQuestionListing
    );
  };
  const handleDuplicateClick = (items) => {
    handleDuplicate(items, (dataToPass) => openModalHelper(dataToPass, setModalData, setIsModalOpen));
  };

  const closeModal = () => {
    closeModalHelper(setIsModalOpen, setModalData, setIsDuplicatePreview);
  };

  useEffect(() => {
    setCurrentPage(1);
    setOffset(0);
  }, [questionCategory]);

  return (
    <>
      <AuthLayout>
        {/* rightpannel top left menu according to different screen  */}
        <RightPanelTopMenu
          setQuestionBankId={setQuestionBankId}
          title={'Question Bank'}
          setOrganisationId={(id) => setOrganizationId(id)}
          showOrgDropdown={true}
        />

        {/* _____ AFTER TOP BAR SECTION : Dynamic for all screens  ______ */}
        <div className={style.question_bank_table_top}>
          <div className={style.question_bank}>
            {/* TOP section of the page where reports result and add new question button  */}
            <div className={style.question_bank_report}>
              <div className={style.results}>
                <div className={style.approved}>
                  <div className={style.box}>
                    <div className={style.icons}>
                      <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M16.8985 29.3346C24.2053 29.3346 30.1837 23.3346 30.1837 16.0013C30.1837 8.66797 24.2053 2.66797 16.8985 2.66797C9.59162 2.66797 3.61328 8.66797 3.61328 16.0013C3.61328 23.3346 9.59162 29.3346 16.8985 29.3346Z"
                          fill="url(#paint0_linear_33_20396)"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M23.2498 11.5162C23.6386 11.907 23.6381 12.5402 23.2486 12.9304L15.7159 20.4771C15.3267 20.867 14.6963 20.8667 14.3074 20.4764L10.5477 16.7031C10.1586 16.3126 10.1586 15.6794 10.5477 15.2889C10.9368 14.8984 11.5677 14.8984 11.9568 15.2889L15.0126 18.3557L21.8407 11.5149C22.2302 11.1247 22.8611 11.1253 23.2498 11.5162Z"
                          fill="white"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_33_20396"
                            x1="30.1837"
                            y1="2.66797"
                            x2="11.3708"
                            y2="24.5912"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#9BF763" />
                            <stop offset="1" stopColor="#25AB5B" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className={style.score}>
                      <p>Approved Question</p>
                      <span>{questionMatrix?.approved}</span>
                    </div>
                  </div>
                </div>

                <div className={style.Rejected}>
                  <div className={style.box}>
                    <div className={style.icons}>
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M15.9993 29.3346C23.3327 29.3346 29.3327 23.3346 29.3327 16.0013C29.3327 8.66797 23.3327 2.66797 15.9993 2.66797C8.66602 2.66797 2.66602 8.66797 2.66602 16.0013C2.66602 23.3346 8.66602 29.3346 15.9993 29.3346Z"
                          fill="url(#paint0_linear_33_20413)"
                        />
                        <path
                          d="M12.2285 12.2266L19.771 19.769"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12.229 19.769L19.7715 12.2266"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_33_20413"
                            x1="29.3327"
                            y1="2.66797"
                            x2="10.5302"
                            y2="24.6584"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FFA78F" />
                            <stop offset="1" stopColor="#F23E2C" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className={style.score}>
                      <p>Rejected Questions</p>
                      <span>{questionMatrix?.rejected}</span>
                    </div>
                  </div>
                </div>

                <div className={style.Review}>
                  <div className={style.box}>
                    <div className={style.icons}>
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle
                          cx="13.0007"
                          cy="12.9974"
                          r="10.6667"
                          transform="rotate(-90 13.0007 12.9974)"
                          stroke="url(#paint0_linear_33_20429)"
                          strokeWidth="3"
                          strokeLinecap="round"
                        />
                        <path
                          d="M13.0006 2.33073C7.10961 2.33073 2.33398 7.10636 2.33398 12.9974C2.33398 18.8884 7.10961 23.6641 13.0007 23.6641"
                          stroke="url(#paint1_linear_33_20429)"
                          strokeWidth="3"
                          strokeLinecap="round"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_33_20429"
                            x1="2.33398"
                            y1="23.6641"
                            x2="26.334"
                            y2="20.3307"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FF8800" />
                            <stop offset="0.380208" stopColor="#FFCF00" />
                            <stop offset="1" stopColor="#FFE8CE" stopOpacity="0" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_33_20429"
                            x1="13.2019"
                            y1="24.2678"
                            x2="13.2019"
                            y2="2.33073"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FF8800" />
                            <stop offset="1" stopColor="#FFCF00" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className={style.score}>
                      <p>Review Questions</p>
                      <span>{questionMatrix?.in_review}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className={style.add_question}>
                <button className={` ${style.add_new_question} ${style.pointer}`} onClick={() => CreateQuestion()}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                      fill="white"
                    />
                    <path
                      d="M7.5 12H16.5"
                      stroke="#00ABFB"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 16.5V7.5"
                      stroke="#00ABFB"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <span> Add New Questions</span>
                </button>
              </div>
            </div>

            {/* TABLE SECTION OF THIS PAGE  */}
            <div className={style.table_content_report}>
              <div className={style.top_content_table}>
                <div className={style.table_title} style={{ width: '36%' }}>
                  <span
                    className={
                      !questionCategory && !isDraft
                        ? ` ${style.underline_active} ${style.pointer}`
                        : ` ${style.pointer}`
                    }
                    onClick={() => ChangeQuestionCategory(false, false)}
                  >
                    My Questions
                  </span>
                  <span
                    className={
                      questionCategory && !isDraft ? ` ${style.underline_active} ${style.pointer}` : ` ${style.pointer}`
                    }
                    onClick={() => ChangeQuestionCategory(true, false)}
                  >
                    All Questions
                  </span>
                  <span
                    className={
                      !questionCategory && isDraft ? ` ${style.underline_active} ${style.pointer}` : ` ${style.pointer}`
                    }
                    onClick={() => {
                      ChangeQuestionCategory(false, true);
                    }}
                  >
                    Drafts
                  </span>
                </div>

                <div className={style.search_listing} style={{ width: '65%' }}>
                  <div className={style.tag_icon}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                        stroke="#212529"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.2598 19.2592L16.1406 16.8594"
                        stroke="#212529"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Tags</span>
                  </div>

                  <div className={style.input_search}>
                    <svg
                      style={{ position: 'relative', top: '10px', left: '14px' }}
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect y="0.5" width="20" height="20" rx="4" fill="#272727" />
                      <path
                        d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                        fill="white"
                      />
                    </svg>
                    <input
                      type="search"
                      style={{ marginLeft: '15px' }}
                      id="searchInput"
                      placeholder="Search for subject, area topic, sub topic, question ID tags to refine list"
                      onChange={(e) => {
                        setCurrentPage(1);
                        setOffset(0);
                        setquestionId(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className={style.filter} style={{ width: '24%', display: 'flex', justifyContent: 'flex-end' }}>
                  <div className={style.pointer} onClick={() => openModalFilter()}>
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill={modalFilter ? '#00ABFB' : 'none'}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.39844 2.60156H18.5984C19.6984 2.60156 20.5984 3.50156 20.5984 4.60156V6.80156C20.5984 7.60156 20.0984 8.60156 19.5984 9.10156L15.2984 12.9016C14.6984 13.4016 14.2984 14.4016 14.2984 15.2016V19.5016C14.2984 20.1016 13.8984 20.9016 13.3984 21.2016L11.9984 22.1016C10.6984 22.9016 8.89844 22.0016 8.89844 20.4016V15.1016C8.89844 14.4016 8.49844 13.5016 8.09844 13.0016L4.29844 9.00156C3.79844 8.50156 3.39844 7.60156 3.39844 7.00156V4.70156C3.39844 3.50156 4.29844 2.60156 5.39844 2.60156Z"
                        stroke={modalFilter ? '#00ABFB' : '#212529'}
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span style={{ color: modalFilter ? '#00ABFB' : '#212529' }}>Filter</span>
                  </div>
                  <button
                    onClick={() => resetFilter()}
                    style={{ cursor: 'pointer', border: 'none', background: 'none' }}
                  >
                    <div className={style.reverse_drop}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.0001 5.40039C11.022 5.40039 10.1345 5.557 9.32483 5.79899C8.92796 5.91759 8.51009 5.69201 8.39148 5.29514C8.27288 4.89827 8.49846 4.4804 8.89532 4.36179C9.82561 4.08378 10.8582 3.90039 12.0001 3.90039C17.2043 3.90039 21.4201 8.11618 21.4201 13.3204C21.4201 18.5246 17.2043 22.7404 12.0001 22.7404C6.79586 22.7404 2.58008 18.5246 2.58008 13.3204C2.58008 11.3868 3.16704 9.58286 4.16604 8.08437C4.3958 7.73972 4.86146 7.64659 5.2061 7.87635C5.55075 8.10612 5.64388 8.57177 5.41412 8.91642C4.57311 10.1779 4.08008 11.694 4.08008 13.3204C4.08008 17.6962 7.62429 21.2404 12.0001 21.2404C16.3759 21.2404 19.9201 17.6962 19.9201 13.3204C19.9201 8.9446 16.3759 5.40039 12.0001 5.40039Z"
                          fill="#272727"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.2516 1.43431C11.564 1.70627 11.5968 2.18001 11.3248 2.49244L8.43485 5.81244C8.16289 6.12487 7.68915 6.15767 7.37672 5.88571C7.0643 5.61375 7.03149 5.14001 7.30345 4.82758L10.1935 1.50758C10.4654 1.19516 10.9392 1.16235 11.2516 1.43431Z"
                          fill="#272727"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.26342 4.87817C7.50764 4.54361 7.97683 4.47037 8.31139 4.71459L11.6814 7.17459C12.0159 7.41881 12.0892 7.888 11.845 8.22256C11.6007 8.55712 11.1316 8.63036 10.797 8.38614L7.427 5.92614C7.09244 5.68192 7.0192 5.21273 7.26342 4.87817Z"
                          fill="#272727"
                        />
                      </svg>
                      <p style={{ margin: '0px', marginLeft: '8px' }}>Reset Filter</p>
                    </div>
                  </button>
                </div>
              </div>

              {/* TABLE LISTING OF ALL AND MY QUESTION  */}
              <div className={`${style.sub_head_content_table} ${style.sub_head_QuestionCard}`}>
                {totalCount > 0 && (
                  <div className={style.sortWrap}>
                    <div className={`${style.sortContainer} ${style.sortAuthorContainer} `}>
                      <span>Author</span>
                      <svg
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSort('created_by');
                        }}
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('created_by'),
                          transition: 'transform 0.3s ease',
                          cursor: 'pointer',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={getIconColor('created_by')}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={getIconColor('created_by')}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={getIconColor('created_by')}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={getIconColor('created_by')}
                        />
                      </svg>
                    </div>
                    <div className={`${style.sortContainer} ${style.sortCreatedonContainer} `}>
                      <span>Created On</span>
                      <svg
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSort('created_at');
                        }}
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('created_at'),
                          transition: 'transform 0.3s ease',
                          cursor: 'pointer',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={getIconColor('created_at')}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={getIconColor('created_at')}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={getIconColor('created_at')}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={getIconColor('created_at')}
                        />
                      </svg>
                    </div>
                    <div className={`${style.sortContainer} ${style.sortLODContainer} `}>
                      <span>LOD</span>
                      <svg
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSort('difficulty__level');
                        }}
                        width="19"
                        height="12"
                        viewBox="0 0 19 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          marginLeft: '6px',
                          transform: getRotation('difficulty__level'),
                          transition: 'transform 0.3s ease',
                          cursor: 'pointer',
                        }}
                      >
                        <path
                          d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                          fill={getIconColor('difficulty__level')}
                        />
                        <path
                          d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                          fill={getIconColor('difficulty__level')}
                        />
                        <path
                          d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                          fill={getIconColor('difficulty__level')}
                        />
                        <path
                          d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                          fill={getIconColor('difficulty__level')}
                        />
                      </svg>
                    </div>
                    {!isDraft && (
                      <div className={`${style.sortContainer} ${style.sortPvalue} `}>
                        <span>P-value</span>
                        <svg
                          onClick={() => handleSort('pvalue')}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            marginLeft: '6px',
                            transform: getRotation('pvalue'),
                            transition: 'transform 0.3s ease',
                            cursor: 'pointer',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={getIconColor('pvalue')}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={getIconColor('pvalue')}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={getIconColor('pvalue')}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={getIconColor('pvalue')}
                          />
                        </svg>
                      </div>
                    )}
                    {!isDraft && (
                      <div className={`${style.sortContainer} ${style.sortStatusContainer} `}>
                        <span>Status</span>
                        <svg
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSort('status');
                          }}
                          width="19"
                          height="12"
                          viewBox="0 0 19 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            marginLeft: '6px',
                            transform: getRotation('status'),
                            transition: 'transform 0.3s ease',
                            cursor: 'pointer',
                          }}
                        >
                          <path
                            d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                            fill={getIconColor('status')}
                          />
                          <path
                            d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                            fill={getIconColor('status')}
                          />
                          <path
                            d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                            fill={getIconColor('status')}
                          />
                          <path
                            d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                            fill={getIconColor('status')}
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                )}

                {/* ALL AND MY QUESTION according to ternary operator */}
                {isLoading ? (
                  <div className={style.loader_message}>Loading...</div>
                ) : (
                  <>
                    {questionCategory &&
                      !isDraft &&
                      (questionResults?.length ? (
                        questionResults?.map((item, i) => (
                          <div key={item.question_id} className={style.questionCard}>
                            {/* Header for Grouped Questions (format: 1) */}
                            {item?.format === 1 && (
                              <div className={style.GroupHeaderWrap}>
                                <div className={style.passageHeader}>
                                  <span>{item.passage_name}</span>
                                </div>
                              </div>
                            )}
                            {item?.format === 1 && item?.passage_name !== null && (
                              <img
                                src={passageVerticalLineSvg}
                                className={`${style.PassageVertical_line} ${style.questionContent}
                                }`}
                                alt="Vertical Line"
                              />
                            )}
                            <div
                              className={`${style.questionContent}
                                     ${style.questionContentExpanded}
                                  `}
                            >
                              {item?.questions?.map((question, questionIndex) => (
                                <div
                                  className={style.questionItem}
                                  style={{
                                    borderBottom:
                                      // Only add border if format is 1 AND not the last question in the group
                                      item?.format === 1 && questionIndex < item?.questions?.length - 1
                                        ? '2px solid #E2ECF080'
                                        : 'none',
                                  }}
                                  key={questionIndex + 1}
                                >
                                  <div className={style.cardHeader}>
                                    <div className={style.cardLeft}>
                                      <div
                                        className={
                                          questionAccess?.view || questionAccess?.edit || questionAccess?.review
                                            ? style.questionId
                                            : style.questionNumber
                                        }
                                        onClick={
                                          questionAccess?.view || questionAccess?.edit || questionAccess?.review
                                            ? () => handleOpenModal(question)
                                            : undefined
                                        }
                                        style={{
                                          cursor:
                                            questionAccess?.view || questionAccess?.edit || questionAccess?.review
                                              ? 'pointer'
                                              : 'default',
                                        }}
                                      >
                                        <span className={style.questionNumber}>ID:</span> {question?.question_id}
                                      </div>
                                    </div>
                                    <div className={style.cardRight}>
                                      <div className={style.status}>
                                        <span style={statusCssHandler(question?.status)}>{question?.status}</span>
                                      </div>
                                      <div>
                                        {questionAccess?.edit ||
                                        questionAccess?.review ||
                                        (questionAccess?.draft && question?.status !== 'Approved') ? (
                                          <div className={` ${style.action} ${style.pointer}`} id="edit">
                                            <svg
                                              onClick={(e) => ActionPerform(question?.question_id, e)}
                                              id="edit"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M12 16C12.5304 16 13.0391 16.2107 13.4142 16.5858C13.7893 16.9609 14 17.4696 14 18C14 18.5304 13.7893 19.0391 13.4142 19.4142C13.0391 19.7893 12.5304 20 12 20C11.4696 20 10.9609 19.7893 10.5858 19.4142C10.2107 19.0391 10 18.5304 10 18C10 17.4696 10.2107 16.9609 10.5858 16.5858C10.9609 16.2107 11.4696 16 12 16ZM12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM12 4C12.5304 4 13.0391 4.21071 13.4142 4.58579C13.7893 4.96086 14 5.46957 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8C11.4696 8 10.9609 7.78929 10.5858 7.41421C10.2107 7.03914 10 6.53043 10 6C10 5.46957 10.2107 4.96086 10.5858 4.58579C10.9609 4.21071 11.4696 4 12 4Z"
                                                fill="#272727"
                                              />
                                            </svg>
                                            <div
                                              className={style.action_button}
                                              id="edit"
                                              style={{
                                                display: actionId === question.question_id ? 'block' : 'none',
                                                fontSize: '12px',
                                              }}
                                            >
                                              {questionAccess?.edit ||
                                              questionAccess?.review ||
                                              (questionAccess?.draft && question?.status !== 'Approved') ? (
                                                <div
                                                  style={{ cursor: 'pointer', display: 'flex', gap: '10px' }}
                                                  id="edit"
                                                  className={style.edit}
                                                  // onClick={() => Edit(items)}
                                                  onClick={() => handleEdit(question)}
                                                >
                                                  {' '}
                                                  <svg
                                                    id="edit"
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M2 14.668H14"
                                                      stroke="#212529"
                                                      strokeWidth="1.5"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                    <path
                                                      d="M8.83958 2.4008L3.36624 8.19413C3.15958 8.41413 2.95958 8.84746 2.91958 9.14746L2.67291 11.3075C2.58624 12.0875 3.14624 12.6208 3.91958 12.4875L6.06624 12.1208C6.36624 12.0675 6.78624 11.8475 6.99291 11.6208L12.4662 5.82746C13.4129 4.82746 13.8396 3.68746 12.3662 2.29413C10.8996 0.914129 9.78624 1.4008 8.83958 2.4008Z"
                                                      stroke="#212529"
                                                      strokeWidth="1.5"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                    <path
                                                      d="M7.92578 3.36719C8.21245 5.20719 9.70578 6.61385 11.5591 6.80052"
                                                      stroke="#212529"
                                                      strokeWidth="1.5"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                  </svg>{' '}
                                                  <span id="edit">Edit</span>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                              {questionAccess?.edit || questionAccess?.review ? (
                                                <div
                                                  className={style.duplicate}
                                                  style={{ cursor: 'pointer', display: 'flex', gap: '10px' }}
                                                  onClick={() => handleDuplicateClick(question)}
                                                >
                                                  <svg
                                                    width="13"
                                                    height="16"
                                                    viewBox="0 0 13 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M9.00065 0.667969H1.66732C0.933984 0.667969 0.333984 1.26797 0.333984 2.0013V10.668C0.333984 11.0346 0.633984 11.3346 1.00065 11.3346C1.36732 11.3346 1.66732 11.0346 1.66732 10.668V2.66797C1.66732 2.3013 1.96732 2.0013 2.33398 2.0013H9.00065C9.36732 2.0013 9.66732 1.7013 9.66732 1.33464C9.66732 0.967969 9.36732 0.667969 9.00065 0.667969ZM11.6673 3.33464H4.33398C3.60065 3.33464 3.00065 3.93464 3.00065 4.66797V14.0013C3.00065 14.7346 3.60065 15.3346 4.33398 15.3346H11.6673C12.4007 15.3346 13.0007 14.7346 13.0007 14.0013V4.66797C13.0007 3.93464 12.4007 3.33464 11.6673 3.33464ZM11.0007 14.0013H5.00065C4.63398 14.0013 4.33398 13.7013 4.33398 13.3346V5.33464C4.33398 4.96797 4.63398 4.66797 5.00065 4.66797H11.0007C11.3673 4.66797 11.6673 4.96797 11.6673 5.33464V13.3346C11.6673 13.7013 11.3673 14.0013 11.0007 14.0013Z"
                                                      fill="#212529"
                                                    />
                                                  </svg>
                                                  <span> Duplicate</span>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </div>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className={style.cardBody}>
                                    {/* Tags Section */}
                                    <div className={style.tags}>
                                      <span className={style.primaryTag}>{question?.primary_tag?.slug}</span>
                                    </div>

                                    {/* Short Identifier */}
                                    <div className={style.questionIdentifier}>
                                      <span className={style.shortIdentifier}>
                                        {question?.question_short_identifier}
                                      </span>
                                    </div>

                                    {/* FreeTags Section */}
                                    <div className={`${style.general_tag} ${style.quasiGeneralTags}`}>
                                      {question?.free_tags?.map((item, i) => (
                                        <button
                                          key={i}
                                          className={`${style.general_button} ${style.generalButtonWrap}`}
                                        >
                                          {item?.name}
                                        </button>
                                      ))}
                                    </div>
                                    {/* Metadata Section */}
                                    <div className={style.Quasimetadata} style={{ width: '80vw', fontSize: '14px' }}>
                                      <div className={style.QuasimetaRowAuthor}>
                                        <span className={style.metaLabel}>Author:</span>
                                        <span className={style.metaauthorValue}>{question?.created_by}</span>
                                      </div>
                                      <div className={style.QuasimetaRowYear}>
                                        <span className={style.metaLabel}>Academic Year:</span>
                                        <span className={style.metaValue}>{question.academic_year}</span>
                                      </div>
                                      <div className={style.QuasimetaRowCreatedOn}>
                                        <span className={style.metaLabel}>Created On:</span>
                                        <span className={style.metaValue}>
                                          {moment(question?.created_at).format('Do MMM YYYY')}
                                        </span>
                                      </div>
                                      <div className={style.QuasimetaRowType}>
                                        <span className={style.metaLabel}>Type:</span>
                                        <span className={style.metaValue}>{question.type}</span>
                                      </div>
                                      <div className={style.QuasimetaRowLOD}>
                                        <span className={style.metaLabel}>LOD:</span>
                                        <span className={style.metaValue}>{question?.difficulty}</span>
                                      </div>
                                      <div className={style.QuasimetaRowPvalue}>
                                        <span className={style.metaLabel}>P-value:</span>
                                        <span className={style.metaValue}>{question?.pvalue}</span>
                                      </div>
                                      <div className={style.QuasimetaRowTestAttempt}>
                                        <span className={style.metaLabel}>Test Attempts:</span>
                                        <span className={style.metaValue}>{question?.test_attempts}</span>
                                      </div>
                                    </div>
                                    {question?.siblings?.length > 0 && (
                                      <div className={style.sibling_div}>
                                        <>
                                          <span className={style.metaLabel}>Siblings:</span>
                                          {question?.siblings?.slice(0, maxSiblingsToShow)?.map((sibling, idx) => (
                                            <React.Fragment key={sibling}>
                                              <span
                                                className={style.underlined}
                                                onClick={() => {
                                                  if (questionAccess?.draft) {
                                                    toast.add(
                                                      'You do not have permission to view this question. Please contact the content management admin to request access rights.',
                                                      'error'
                                                    );
                                                  } else {
                                                    handleOpenModal(sibling);
                                                  }
                                                }}
                                              >
                                                {sibling}
                                              </span>
                                              {idx < question?.siblings?.slice(0, maxSiblingsToShow + 1).length - 1 &&
                                                ' | '}
                                            </React.Fragment>
                                          ))}

                                          {question?.siblings?.length > maxSiblingsToShow && (
                                            <>
                                              {showMoreState[question?.question_id] &&
                                                question?.siblings?.slice(maxSiblingsToShow).map((sibling, idx) => (
                                                  <React.Fragment key={sibling}>
                                                    <span
                                                      className={`${style.underlined} ${style.metaValue}`}
                                                      onClick={() => {
                                                        if (questionAccess?.draft) {
                                                          toast.add(
                                                            'You do not have permission to view this question. Please contact the content management admin to request access rights.',
                                                            'error'
                                                          );
                                                        } else {
                                                          handleOpenModal(sibling);
                                                        }
                                                      }}
                                                    >
                                                      {sibling}
                                                    </span>
                                                    {idx < question?.siblings?.slice(maxSiblingsToShow).length - 1 &&
                                                      ' | '}
                                                  </React.Fragment>
                                                ))}
                                              <span
                                                onClick={() => toggleShowMore(question?.question_id)} // Toggle specific row's state
                                                className={style.moreLink}
                                              >
                                                {showMoreState[question?.question_id]
                                                  ? 'Show less'
                                                  : `${question?.siblings?.length - maxSiblingsToShow} More`}
                                              </span>
                                            </>
                                          )}
                                        </>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className={style.cardContainer}>
                          <h2 className={style.cardtitle}>No Results Found!</h2>
                          <p className={style.carddescription}>Please click “Add New Questions” button to proceed.</p>
                        </div>
                      ))}
                    {!questionCategory &&
                      !isDraft &&
                      (myquestionResults?.length ? (
                        myquestionResults?.map((item, i) => (
                          <>
                            <div key={item.question_id} className={style.questionCard}>
                              {/* Header for Grouped Questions (format: 1) */}
                              {item?.format === 1 && (
                                <div className={style.GroupHeaderWrap}>
                                  <div className={style.passageHeader}>
                                    <span>{item.passage_name}</span>
                                  </div>
                                </div>
                              )}
                              {item?.format === 1 && item?.passage_name !== null && (
                                <img
                                  src={passageVerticalLineSvg}
                                  className={`${style.PassageVertical_line} ${style.questionContent}
                                }`}
                                  alt="Vertical Line"
                                />
                              )}
                              <div
                                className={`${style.questionContent}
                                     ${style.questionContentExpanded}
                                  `}
                              >
                                {item?.questions?.map((question, questionIndex) => (
                                  <div
                                    className={style.questionItem}
                                    style={{
                                      borderBottom:
                                        // Only add border if format is 1 AND not the last question in the group
                                        item?.format === 1 && questionIndex < item?.questions?.length - 1
                                          ? '2px solid #E2ECF080'
                                          : 'none',
                                    }}
                                  >
                                    <div className={style.cardHeader}>
                                      <div className={style.cardLeft}>
                                        {/* Question ID with Clickable Modal */}
                                        <div
                                          className={
                                            questionAccess?.view || questionAccess?.edit || questionAccess?.review
                                              ? style.questionId
                                              : style.questionNumber
                                          }
                                          onClick={
                                            questionAccess?.view || questionAccess?.edit || questionAccess?.review
                                              ? () => handleOpenModal(question)
                                              : undefined
                                          }
                                          style={{
                                            cursor:
                                              questionAccess?.view || questionAccess?.edit || questionAccess?.review
                                                ? 'pointer'
                                                : 'default',
                                          }}
                                        >
                                          <span className={style.questionNumber}>ID:</span> {question?.question_id}
                                        </div>
                                      </div>
                                      <div className={style.cardRight}>
                                        <div className={style.status}>
                                          <span style={statusCssHandler(question?.status)}>{question?.status}</span>
                                        </div>
                                        <div>
                                          {questionAccess?.edit ||
                                          questionAccess?.review ||
                                          (questionAccess?.draft && question?.status !== 'Approved') ? (
                                            <div className={` ${style.action} ${style.pointer}`} id="edit">
                                              <svg
                                                onClick={(e) => ActionPerform(question?.question_id, e)}
                                                id="edit"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M12 16C12.5304 16 13.0391 16.2107 13.4142 16.5858C13.7893 16.9609 14 17.4696 14 18C14 18.5304 13.7893 19.0391 13.4142 19.4142C13.0391 19.7893 12.5304 20 12 20C11.4696 20 10.9609 19.7893 10.5858 19.4142C10.2107 19.0391 10 18.5304 10 18C10 17.4696 10.2107 16.9609 10.5858 16.5858C10.9609 16.2107 11.4696 16 12 16ZM12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM12 4C12.5304 4 13.0391 4.21071 13.4142 4.58579C13.7893 4.96086 14 5.46957 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8C11.4696 8 10.9609 7.78929 10.5858 7.41421C10.2107 7.03914 10 6.53043 10 6C10 5.46957 10.2107 4.96086 10.5858 4.58579C10.9609 4.21071 11.4696 4 12 4Z"
                                                  fill="#272727"
                                                />
                                              </svg>
                                              <div
                                                className={style.action_button}
                                                id="edit"
                                                style={{
                                                  display: actionId === question.question_id ? 'block' : 'none',
                                                  fontSize: '12px',
                                                }}
                                              >
                                                {questionAccess?.edit ||
                                                questionAccess?.review ||
                                                (questionAccess?.draft && question?.status !== 'Approved') ? (
                                                  <div
                                                    style={{ cursor: 'pointer', display: 'flex', gap: '10px' }}
                                                    id="edit"
                                                    className={style.edit}
                                                    // onClick={() => Edit(items)}
                                                    onClick={() => handleEdit(question)}
                                                  >
                                                    {' '}
                                                    <svg
                                                      id="edit"
                                                      width="16"
                                                      height="16"
                                                      viewBox="0 0 16 16"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                      <path
                                                        d="M2 14.668H14"
                                                        stroke="#212529"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                      />
                                                      <path
                                                        d="M8.83958 2.4008L3.36624 8.19413C3.15958 8.41413 2.95958 8.84746 2.91958 9.14746L2.67291 11.3075C2.58624 12.0875 3.14624 12.6208 3.91958 12.4875L6.06624 12.1208C6.36624 12.0675 6.78624 11.8475 6.99291 11.6208L12.4662 5.82746C13.4129 4.82746 13.8396 3.68746 12.3662 2.29413C10.8996 0.914129 9.78624 1.4008 8.83958 2.4008Z"
                                                        stroke="#212529"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                      />
                                                      <path
                                                        d="M7.92578 3.36719C8.21245 5.20719 9.70578 6.61385 11.5591 6.80052"
                                                        stroke="#212529"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                      />
                                                    </svg>{' '}
                                                    <span id="edit">Edit</span>
                                                  </div>
                                                ) : (
                                                  <></>
                                                )}
                                                {questionAccess?.edit || questionAccess?.review ? (
                                                  <div
                                                    className={style.duplicate}
                                                    style={{ cursor: 'pointer', display: 'flex', gap: '10px' }}
                                                    onClick={() => handleDuplicateClick(question)}
                                                  >
                                                    <svg
                                                      width="13"
                                                      height="16"
                                                      viewBox="0 0 13 16"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                      <path
                                                        d="M9.00065 0.667969H1.66732C0.933984 0.667969 0.333984 1.26797 0.333984 2.0013V10.668C0.333984 11.0346 0.633984 11.3346 1.00065 11.3346C1.36732 11.3346 1.66732 11.0346 1.66732 10.668V2.66797C1.66732 2.3013 1.96732 2.0013 2.33398 2.0013H9.00065C9.36732 2.0013 9.66732 1.7013 9.66732 1.33464C9.66732 0.967969 9.36732 0.667969 9.00065 0.667969ZM11.6673 3.33464H4.33398C3.60065 3.33464 3.00065 3.93464 3.00065 4.66797V14.0013C3.00065 14.7346 3.60065 15.3346 4.33398 15.3346H11.6673C12.4007 15.3346 13.0007 14.7346 13.0007 14.0013V4.66797C13.0007 3.93464 12.4007 3.33464 11.6673 3.33464ZM11.0007 14.0013H5.00065C4.63398 14.0013 4.33398 13.7013 4.33398 13.3346V5.33464C4.33398 4.96797 4.63398 4.66797 5.00065 4.66797H11.0007C11.3673 4.66797 11.6673 4.96797 11.6673 5.33464V13.3346C11.6673 13.7013 11.3673 14.0013 11.0007 14.0013Z"
                                                        fill="#212529"
                                                      />
                                                    </svg>
                                                    <span> Duplicate</span>
                                                  </div>
                                                ) : (
                                                  <></>
                                                )}
                                              </div>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    <div className={style.cardBody}>
                                      {/* Tags Section */}
                                      <div className={style.tags}>
                                        <span className={style.primaryTag}>{question?.primary_tag?.slug}</span>
                                      </div>

                                      {/* Short Identifier */}
                                      <div className={style.questionIdentifier}>
                                        <span className={style.shortIdentifier}>
                                          {question?.question_short_identifier}
                                        </span>
                                      </div>

                                      {/* FreeTags Section */}
                                      <div className={`${style.general_tag} ${style.quasiGeneralTags}`}>
                                        {question?.free_tags?.map((item, i) => (
                                          <button
                                            key={i}
                                            className={`${style.general_button} ${style.generalButtonWrap}`}
                                          >
                                            {item?.name}
                                          </button>
                                        ))}
                                      </div>
                                      {/* Metadata Section */}
                                      <div className={style.Quasimetadata} style={{ width: '80vw', fontSize: '14px' }}>
                                        <div className={style.QuasimetaRowAuthor}>
                                          <span className={style.metaLabel}>Author:</span>
                                          <span className={style.metaauthorValue}>{question?.created_by}</span>
                                        </div>
                                        <div className={style.QuasimetaRowYear}>
                                          <span className={style.metaLabel}>Academic Year:</span>
                                          <span className={style.metaValue}>{question.academic_year}</span>
                                        </div>
                                        <div className={style.QuasimetaRowCreatedOn}>
                                          <span className={style.metaLabel}>Created On:</span>
                                          <span className={style.metaValue}>
                                            {moment(question?.created_at).format('Do MMM YYYY')}
                                          </span>
                                        </div>
                                        <div className={style.QuasimetaRowType}>
                                          <span className={style.metaLabel}>Type:</span>
                                          <span className={style.metaValue}>{question.type}</span>
                                        </div>
                                        <div className={style.QuasimetaRowLOD}>
                                          <span className={style.metaLabel}>LOD:</span>
                                          <span className={style.metaValue}>{question?.difficulty}</span>
                                        </div>
                                        <div className={style.QuasimetaRowPvalue}>
                                          <span className={style.metaLabel}>P-value:</span>
                                          <span className={style.metaValue}>{question?.pvalue}</span>
                                        </div>
                                        <div className={style.QuasimetaRowTestAttempt}>
                                          <span className={style.metaLabel}>Test Attempts:</span>
                                          <span className={style.metaValue}>{question?.test_attempts}</span>
                                        </div>
                                      </div>
                                      {question?.siblings?.length > 0 && (
                                        <div className={style.sibling_div}>
                                          <>
                                            <span className={style.metaLabel}>Siblings:</span>
                                            {question?.siblings?.slice(0, maxSiblingsToShow)?.map((sibling, idx) => (
                                              <React.Fragment key={sibling}>
                                                <span
                                                  className={style.underlined}
                                                  onClick={() => {
                                                    if (questionAccess?.draft) {
                                                      toast.add(
                                                        'You do not have permission to view this question. Please contact the content management admin to request access rights.',
                                                        'error'
                                                      );
                                                    } else {
                                                      handleOpenModal(sibling);
                                                    }
                                                  }}
                                                >
                                                  {sibling}
                                                </span>
                                                {idx < question?.siblings?.slice(0, maxSiblingsToShow + 1).length - 1 &&
                                                  ' | '}
                                              </React.Fragment>
                                            ))}

                                            {question?.siblings?.length > maxSiblingsToShow && (
                                              <>
                                                {showMoreState[question?.question_id] &&
                                                  question?.siblings?.slice(maxSiblingsToShow).map((sibling, idx) => (
                                                    <React.Fragment key={sibling}>
                                                      <span
                                                        className={`${style.underlined} ${style.metaValue}`}
                                                        onClick={() => {
                                                          if (questionAccess?.draft) {
                                                            toast.add(
                                                              'You do not have permission to view this question. Please contact the content management admin to request access rights.',
                                                              'error'
                                                            );
                                                          } else {
                                                            handleOpenModal(sibling);
                                                          }
                                                        }}
                                                      >
                                                        {sibling}
                                                      </span>
                                                      {idx < question?.siblings?.slice(maxSiblingsToShow).length - 1 &&
                                                        ' | '}
                                                    </React.Fragment>
                                                  ))}
                                                <span
                                                  onClick={() => toggleShowMore(question?.question_id)} // Toggle specific row's state
                                                  className={style.moreLink}
                                                >
                                                  {showMoreState[question?.question_id]
                                                    ? 'Show less'
                                                    : `${question?.siblings?.length - maxSiblingsToShow} More`}
                                                </span>
                                              </>
                                            )}
                                          </>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        ))
                      ) : (
                        <div className={style.cardContainer}>
                          <h2 className={style.cardtitle}>No Results Found!</h2>
                          <p className={style.carddescription}>Please click “Add New Questions” button to proceed.</p>
                        </div>
                      ))}
                    {!questionCategory &&
                      isDraft &&
                      (myquestionResults?.length ? (
                        myquestionResults?.map((item, i) => (
                          <div key={item?.question_draft_id} className={style.questionCard}>
                            {/* Header for Grouped Questions (format: 1) */}
                            {item?.format === 1 && (
                              <div className={style.GroupHeaderWrap}>
                                <div className={style.passageHeader}>
                                  <span>{item.passage_name}</span>
                                </div>
                              </div>
                            )}
                            {item?.format === 1 && item?.passage_name !== null && (
                              <img
                                src={passageVerticalLineSvg}
                                className={`${style.PassageVertical_line} ${style.questionContent}
                                }`}
                                alt="Vertical Line"
                              />
                            )}
                            <div
                              className={`${style.questionContent}
                                     ${style.questionContentExpanded}
                                  `}
                            >
                              <div className={style.questionItem}>
                                <div className={style.cardHeader}>
                                  <div className={style.cardLeft}>
                                    {/* Question ID with Clickable Modal */}
                                    <div className={style.questionId} style={{ cursor: 'auto' }}>
                                      <span className={style.questionNumber}>ID:</span> {item?.question_draft_id}
                                    </div>
                                  </div>
                                  <div className={style.cardRight}>
                                    <div className={style.status}>
                                      <span style={statusCssHandler(item?.status)}>{item?.status}</span>
                                    </div>
                                    <>
                                      {questionAccess?.edit || questionAccess?.review || questionAccess?.draft ? (
                                        <div className={` ${style.action} ${style.pointer}`} id="edit">
                                          <svg
                                            onClick={(e) => ActionPerform(item?.question_draft_id, e)}
                                            id="edit"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M12 16C12.5304 16 13.0391 16.2107 13.4142 16.5858C13.7893 16.9609 14 17.4696 14 18C14 18.5304 13.7893 19.0391 13.4142 19.4142C13.0391 19.7893 12.5304 20 12 20C11.4696 20 10.9609 19.7893 10.5858 19.4142C10.2107 19.0391 10 18.5304 10 18C10 17.4696 10.2107 16.9609 10.5858 16.5858C10.9609 16.2107 11.4696 16 12 16ZM12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM12 4C12.5304 4 13.0391 4.21071 13.4142 4.58579C13.7893 4.96086 14 5.46957 14 6C14 6.53043 13.7893 7.03914 13.4142 7.41421C13.0391 7.78929 12.5304 8 12 8C11.4696 8 10.9609 7.78929 10.5858 7.41421C10.2107 7.03914 10 6.53043 10 6C10 5.46957 10.2107 4.96086 10.5858 4.58579C10.9609 4.21071 11.4696 4 12 4Z"
                                              fill="#272727"
                                            />
                                          </svg>
                                          <div
                                            className={style.action_button}
                                            id="edit"
                                            style={{
                                              display: actionId === item?.question_draft_id ? 'block' : 'none',
                                              fontSize: '12px',
                                            }}
                                          >
                                            {
                                              <div
                                                style={{ cursor: 'pointer', display: 'flex', gap: '10px' }}
                                                id="edit"
                                                className={style.edit}
                                                onClick={() => handleEdit(item)}
                                              >
                                                {' '}
                                                <svg
                                                  id="edit"
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M2 14.668H14"
                                                    stroke="#212529"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  />
                                                  <path
                                                    d="M8.83958 2.4008L3.36624 8.19413C3.15958 8.41413 2.95958 8.84746 2.91958 9.14746L2.67291 11.3075C2.58624 12.0875 3.14624 12.6208 3.91958 12.4875L6.06624 12.1208C6.36624 12.0675 6.78624 11.8475 6.99291 11.6208L12.4662 5.82746C13.4129 4.82746 13.8396 3.68746 12.3662 2.29413C10.8996 0.914129 9.78624 1.4008 8.83958 2.4008Z"
                                                    stroke="#212529"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  />
                                                  <path
                                                    d="M7.92578 3.36719C8.21245 5.20719 9.70578 6.61385 11.5591 6.80052"
                                                    stroke="#212529"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  />
                                                </svg>{' '}
                                                <span id="edit">Edit</span>
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  </div>
                                </div>

                                <div className={style.cardBody}>
                                  {/* Tags Section */}
                                  {item?.primary_tag?.slug && (
                                    <div className={style.tags}>
                                      <span className={style.primaryTag}>{item?.primary_tag?.slug}</span>
                                    </div>
                                  )}

                                  {/* Short Identifier */}
                                  {item?.question_short_identifier && (
                                    <div className={style.questionIdentifier}>
                                      <span className={style.shortIdentifier}>{item?.question_short_identifier}</span>
                                    </div>
                                  )}

                                  {/* FreeTags Section */}
                                  {item?.free_tags?.length > 0 && (
                                    <div className={`${style.general_tag} ${style.quasiGeneralTags}`}>
                                      {item?.free_tags?.map((item, i) => (
                                        <button
                                          key={i}
                                          className={`${style.general_button} ${style.generalButtonWrap}`}
                                        >
                                          {item?.name}
                                        </button>
                                      ))}
                                    </div>
                                  )}
                                  {/* Metadata Section */}
                                  <div className={style.Quasimetadata} style={{ width: '80vw', fontSize: '14px' }}>
                                    <div className={style.QuasimetaRowAuthor}>
                                      <span className={style.metaLabel}>Author:</span>
                                      <span className={style.metaauthorValue}>{item?.created_by}</span>
                                    </div>
                                    <div className={style.QuasimetaRowYear}>
                                      <span className={style.metaLabel}>Academic Year:</span>
                                      <span className={style.metaValue}>{item?.academic_year}</span>
                                    </div>
                                    <div className={style.QuasimetaRowCreatedOn}>
                                      <span className={style.metaLabel}>Created On:</span>
                                      <span className={style.metaValue}>
                                        {moment(item?.created_at).format('Do MMM YYYY')}
                                      </span>
                                    </div>
                                    <div className={style.QuasimetaRowType}>
                                      <span className={style.metaLabel}>Type:</span>
                                      <span className={style.metaValue}>{item?.type}</span>
                                    </div>
                                    <div className={style.QuasimetaRowLOD} style={{ borderRight: 'none' }}>
                                      <span className={style.metaLabel}>LOD:</span>
                                      <span className={style.metaValue}>{item?.difficulty}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className={style.cardContainer}>
                          <h2 className={style.cardtitle}>No Results Found!</h2>
                          <p className={style.carddescription}>Please click “Add New Questions” button to proceed.</p>
                        </div>
                      ))}
                  </>
                )}
              </div>
            </div>

            {/*______________________________ PAGINATION ______________________________  */}
            <div className={style.listpaginationWrap}>
              <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                limit={limit}
                totalCount={totalCount}
                offset={offset}
                setOffset={setOffset}
                isLoading={isLoading}
              />
            </div>
            {/*______________________________ PAGINATION ______________________________  */}
          </div>
        </div>
      </AuthLayout>
      {/* FILTER MODAL CALL for filteration on searching  */}
      <FilterModal
        usedFor={0}
        questionCategory={questionCategory}
        QuestionListing={QuestionListing}
        MyQuestionListing={MyQuestionListing}
        modalFilter={modalFilter}
        closeModalFilter={closeModalFilter}
        multiselectedSubjectTag={multiselectedSubjectTag}
        setmultiSelectedSubjectTag={setmultiSelectedSubjectTag}
        multiselectedFreeTag={multiselectedFreeTag}
        setmultiSelectedFreeTag={setmultiSelectedFreeTag}
        multiselectedCategoryTag={multiselectedCategoryTag}
        setmultiSelectedCategoryTag={setmultiSelectedCategoryTag}
        multiselectedAuthorTag={multiselectedAuthorTag}
        setmultiSelectedAuthorTag={setmultiSelectedAuthorTag}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedYearExclude={selectedYearExclude}
        setSelectedYearExclude={setSelectedYearExclude}
        setQuestionType={setQuestionType}
        questionType={questionType}
        setQuestionFormat={setQuestionFormat}
        questionFormat={questionFormat}
        difficultyLevel={difficultyLevel}
        setDifficultyLevel={setDifficultyLevel}
        currentYear={currentYear}
      />
      {isPreviewopen && (
        <PreviewModal
          onEdit={handleEdit}
          questionAccess={questionAccess}
          selectedQuestion={selectedQuestion}
          isOpen={isPreviewopen}
          onClose={handleCloseModal}
          setIsDuplicateModalOpen={setIsModalOpen}
          setModalData={setModalData}
          modalData={modalData}
          setIsDuplicatePreview={setIsDuplicatePreview}
          iframeSrc="/question-content-url"
        />
      )}
      {isModalOpen && (
        <QuestionListModal
          isOpen={isModalOpen}
          onClose={closeModal}
          onConfirm={onConfirmDuplicate}
          data={modalData} // Pass modalData to the modal
          isDuplicatePreview={isDuplicatePreview}
        />
      )}
      <LockModal
        modalData={modalModalData}
        forwardButton={() => navigate('/edit-question', { state: questionItem })}
        modalMedium={modalMedium}
        closeModalMedium={closeModalMedium}
      />
    </>
  );
};

export default QuestionBank;
